// eslint:disable max-line-length
import { validationHighlights } from 'app/area/administration/shared/helpers';
import { CodetableTranslation } from 'app/area/codetable/constants';
import {
  shouldRenderDetails, shouldRenderTranslations, shouldRenderTypes, shouldRenderVisibility
} from 'app/area/codetable/item/codetable-item-form-render-helpers';
import { supportedScreens } from 'app/area/codetable/item/screen-renderer/supported-screens';
import { ScreenField, ScreenPicker } from 'app/area/codetable/item/screen-renderer/types';
import { CodeEditSectionType, MetroLineConfigurationPayload } from 'app/area/codetable/item/types';
import { CodeFieldFlagWireKey, CodeFieldWireKey, CodetableFeature } from 'app/area/codetable/types-store';
import { Configuration } from 'app/components/metro-line/types';
import { routeConstants } from 'app/routes/route-constants';

export const severityConfiguration = ({ metadata, breadcrumbs, codeId, actionType, validationErrors,
  detailsSectionRef, riskMatrixConfigurationRef, translationsSectionRef, visibilitySectionRef, typesRef
}: MetroLineConfigurationPayload):
  Configuration<CodeEditSectionType>[] => {
  const screenData = supportedScreens.find(screen => screen.id === metadata.codetable.id && screen.name === metadata.formName);
  return ([
    {
      section: CodeEditSectionType.RiskMatrixReminderSection,
      visible: true,
      iconUrl: '/i/case-sections/where-and-what.svg',
      url: routeConstants.codetableAdministrationCodeSectionFor(
        breadcrumbs, codeId, CodeEditSectionType.RiskMatrixReminderSection, actionType
      ),
      label: (translation: CodetableTranslation) => translation.risk_matrix_configuration,
      ref: riskMatrixConfigurationRef,
      isValid: true
    },
    {
      section: CodeEditSectionType.Details,
      visible: shouldRenderDetails(metadata, screenData?.screenSlots?.details),
      iconUrl: '/i/case-sections/default.svg',
      url: routeConstants.codetableAdministrationCodeSectionFor(breadcrumbs, codeId, CodeEditSectionType.Details, actionType),
      label: (translation: CodetableTranslation) => translation.details,
      ref: detailsSectionRef,
      isValid: validationHighlights([CodeFieldFlagWireKey.scoreCalcWeight,
      CodetableFeature.parent, CodetableFeature.node, CodetableFeature.category, CodetableFeature.icon, CodeFieldWireKey.colourCode,
      ScreenPicker.likelihood, ScreenPicker.recurrence, ScreenPicker.severity, ScreenPicker.uom,
      ScreenField.low, ScreenField.mid, ScreenField.high, ScreenField.scoreCalcWeight, ScreenField.companyRegisterId,
      ScreenPicker.uomTypeFrom, ScreenPicker.uomTypeTo], validationErrors)
    },
    {
      section: CodeEditSectionType.Visibility,
      visible: shouldRenderVisibility(metadata, screenData?.screenSlots?.visibility),
      iconUrl: '/i/case-sections/where-and-what.svg',
      url: routeConstants.codetableAdministrationCodeSectionFor(breadcrumbs, codeId, CodeEditSectionType.Visibility, actionType),
      label: (translation: CodetableTranslation) => translation.visibility,
      ref: visibilitySectionRef,
      isValid: validationHighlights([CodeFieldWireKey.application, CodeFieldWireKey.subset], validationErrors)
    },
    {
      section: CodeEditSectionType.Types,
      visible: shouldRenderTypes(metadata, screenData?.screenSlots?.types),
      iconUrl: '/i/case-sections/default.svg',
      url: routeConstants.codetableAdministrationCodeSectionFor(breadcrumbs, codeId, CodeEditSectionType.Types, actionType),
      label: (translation: CodetableTranslation) => translation.types,
      ref: typesRef,
      isValid: validationHighlights([CodeFieldWireKey.class], validationErrors)
    },
    {
      section: CodeEditSectionType.Translations,
      visible: shouldRenderTranslations(metadata, screenData?.screenSlots?.translations),
      url: routeConstants.codetableAdministrationCodeSectionFor(breadcrumbs, codeId, CodeEditSectionType.Translations, actionType),
      iconUrl: '/i/case-sections/actions.svg',
      label: (translation: CodetableTranslation) => translation.descriptions_and_translations,
      ref: translationsSectionRef,
      isValid: validationHighlights(['language'], validationErrors)
    }
  ]);
};
